import { getTextVariation, lookup } from 'scoreboard-colors'
import constants from 'scoreboard/components/constants'
const { COLORED_CELL_BG_OPACITY, TEXT_VARIATION_THRESHOLD } = constants

/*
 * Applies color variations to table cell content based on the color of the cell
 * and the style type.
 */

export function applyColorStyles(result, color) {
	result.style['color'] = true
	result.style[color] = true
	let lookupColor = lookup(color).color

	// Check for fill or text style
	if (result.style.fill || !result.style.text) {
		result.style['label-on-colored-background'] = true

		// If it's not a fill, apply triangle style
		if (!result.style.fill) {
			result.style['triangle'] = true
		}

		let textVariation = getTextVariation(lookupColor, COLORED_CELL_BG_OPACITY)
		result.style[textVariation] = true
	} else if (result.style.text) {
		let textVariation = getTextVariation(lookupColor, COLORED_CELL_BG_OPACITY, TEXT_VARIATION_THRESHOLD)
		result.style[textVariation] = true
	}
}